var exports = {
  "k": "x61f99309--779ea8--container",
  "Q": "x61f99309--779ea8--text",
};

module.exports = exports;
